import { render } from "./sending-method.vue?vue&type=template&id=c1c13bf6&scoped=true"
import script from "./sending-method.vue?vue&type=script&lang=js"
export * from "./sending-method.vue?vue&type=script&lang=js"

import "./sending-method.vue?vue&type=style&index=0&id=c1c13bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c13bf6"]])

export default __exports__